<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "SwitchAutomatorEditorModal",
  components: {
    ModalWrapperChoice
  },
  props: {
    callback: {
      type: Function,
      required: false,
      default: () => ({})
    },
    lostBlocks: {
      type: Number,
      required: false,
      default: 0,
    }
  },
  data() {
    return {
      errorCount: 0,
      isCurrentlyBlocks: false
    };
  },
  computed: {
    currentScriptID: {
      get() {
        return this.$viewModel.tabs.reality.automator.editorScriptID;
      },
      set(value) {
        this.$viewModel.tabs.reality.automator.editorScriptID = value;
      }
    },
    otherMode() {
      return this.isCurrentlyBlocks ? "Текст" : "Блок";
    }
  },
  methods: {
    update() {
      this.errorCount = AutomatorData.currentErrors().length;
      this.isCurrentlyBlocks = player.reality.automator.type === AUTOMATOR_TYPE.BLOCK;
    },
    toggleAutomatorMode() {
      AutomatorBackend.changeModes(this.currentScriptID);
      this.callback?.();
    }
  }
};
</script>

<template>
  <ModalWrapperChoice
    option="switchAutomatorMode"
    @confirm="toggleAutomatorMode"
  >
    <template #header>
      Изменить Автоматизатор на редактор {{ otherMode }}
    </template>
    <div class="c-modal-message__text">
      Это остановит ваш текущий скрипт если он запущен!
      <div v-if="errorCount">
        <br>
        Ваш скрипт содержит ошибки, которые могут некорректно конвертироваться в режим {{ otherMode }}. Продолжение
        заставит Автоматизатор всё равно попытаться спарсить это строки, хотя некоторая информация может быть утеряна
        или конвертироваться некорректно.
      </div>
      <!-- Note: this can only ever appear on text-to-block -->
      <b v-if="lostBlocks">
        <br>
        Предупреждение: Ваш скрипт также имеет некоторые строки, которые не могут быть интерпретированы как конкретные
        команды. Эти строки будут удалены, так как не существует блока, в который они могут быть конвертированы.
        Если ошибка возникает в начале петли или IF, это может удалить большие части вашего скрипта!
        <span class="l-lost-text">
          Смена режимов редактирования прямо сейчас приведёт к необратимой потере {{ lostBlocks }} линий кода!
        </span>
      </b>
      <br>
      <span class="l-lost-text">
        Скрытие этого подтверждение не рекомендуется, так как оно может привести к немедленной и необратимой потере
        некоторых частей скрипта, если ваш скрипт содержит ошибки на момент переключения режимов.
      </span>
      <br>
      <br>
      Вы уверены, что хотите изменить режим на {{ otherMode }}?
    </div>
    <template #confirm-text>
      Сменить Режимы
    </template>
  </ModalWrapperChoice>
</template>

<style scoped>
.l-lost-text {
  color: var(--color-bad);
}
</style>
